import { render, staticRenderFns } from "./TrAnalysisDgaGraph.vue?vue&type=template&id=8fc9dd9c&scoped=true"
import script from "./TrAnalysisDgaGraph.vue?vue&type=script&lang=ts"
export * from "./TrAnalysisDgaGraph.vue?vue&type=script&lang=ts"
import style0 from "./TrAnalysisDgaGraph.vue?vue&type=style&index=0&id=8fc9dd9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fc9dd9c",
  null
  
)

export default component.exports